<template>
  <BModal v-model="isOpen" size="lg" centered hide-footer hide-header>
    <OrderSend @close="close()"/>
  </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue';
import OrderSend from './OrderSend';

export default {
  props: {
    redirectToAfterClose: {},
  },
  components: {
    BModal,
    OrderSend,
  },
  computed: {
    isOpen: {
      get() {
        return this.$store.state.orders.isSendOrderModalOpen;
      },
      set(val) {
        this.$store.commit('orders/isSendOrderModalOpen', {
          isOpen: val,
        });
        if (this.redirectToAfterClose) {
          this.$router.push(this.redirectToAfterClose);
        }
      },
    },
  },
  methods: {
    close() {
      this.isOpen = false;
    },
  },
};
</script>
